// @ts-strict-ignore
import { AdSlot, CollapseButton, TEMPLATE, TemplateStateHandler } from '@wikia/ad-engine';
import { Inject, Injectable } from '@wikia/dependency-injection';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CloseButtonHelper } from '../../helpers/close-button-helper';
import { UapDomManager } from '../../helpers/uap-dom-manager';

@Injectable({ autobind: false })
export class BflaCollapseToStaticButtonHandler implements TemplateStateHandler {
	private unsubscribe$ = new Subject<void>();
	private button: HTMLButtonElement;

	constructor(
		@Inject(TEMPLATE.SLOT) private adSlot: AdSlot,
		private helper: CloseButtonHelper,
		private manager: UapDomManager,
	) {}

	async onEnter(): Promise<void> {
		this.button = new CollapseButton({
			onClick: () => {
				const iframe = this.adSlot.getIframe();

				if (iframe) {
					// Stop the Youtube video
					iframe.contentWindow.postMessage('stopVideo', '*');

					// Show background image
					this.manager.setImpactImage();

					// Set the slot height to resolved
					this.manager.setSlotHeightResolved();
					this.manager.setPlaceholderHeightResolved();

					// Hide collapse button icon
					this.button.style.display = 'none';
				}
			},
		}).render();

		this.helper.appendOnViewed(this.button).pipe(takeUntil(this.unsubscribe$)).subscribe();
	}

	async onLeave(): Promise<void> {
		this.unsubscribe$.next();
		this.button.remove();
	}
}
